// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__M289M","pulse":"styles_pulse__TOl70","btn":"styles_btn__MDGv1","btn-outline-secondary":"styles_btn-outline-secondary___ksLi","jump":"styles_jump__dY8rA"};